import{e as r,m as c}from"./chunk-HBP5N4FR.js";var x,s=r(()=>{c();x=(e,i)=>{let t=[],n=e.indexOf(i,0);for(;n>=0;)t.push(n),n=e.indexOf(i,n+1);return t}});export{x as a,s as b};
//# sourceMappingURL=chunk-ZYJTJW6F.js.map
